import { SET_PRELOADER } from '../../../helpers/action-types';
import { ICON } from './actions';

const initialState = {
    message: null,
    icon: ICON.NONE
};

const reducer = (state = initialState, action = { type: null }) => {
    return action.type === SET_PRELOADER ? {
        ...state,
        message: action.message,
        icon: action.icon
    } : state;
};

export default reducer;
